//
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor por nombre',
            model: ProviderModel,
            noObject: true,
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'rut',
            itemValue: 'id',
            label: 'Proveedor por rut',
            model: ProviderModel,
            noObject: true,
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Vencimiento',
        },
    },
]
